export default __webpack_public_path__ + "static/gorgias_logo-5628a7f0793f9872abaa78af6df3578e.png";